import {GESTION_OPERATIVA_CHANGED_CLIENT} from "../constants"

export function changedClient(client) {
    return  (dispatch) => {
      dispatch({
        type: GESTION_OPERATIVA_CHANGED_CLIENT,
        data: {client}
      })
    }
  }